import React from "react";
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router-dom";
import ConsoleLogger from "../Utils/ConsoleLogger";
import Loading from 'react-loading-bar';
import 'react-loading-bar/dist/index.css';
import Footer from "./Footer";
import ContactForm from "./ContactForm";
import CustomMap from "./CustomMap";
import FeaturesSection from "./FeaturesSection";
import Description from "./Description";
import Sliderimages from "./Sliderimages";


let config = require('../Config/appConfig.json');
let UR_GET_ROUTE_DETAILS = config.GET_ROUTE_DETAILS;
let URL_DECODE_POLYLINE = config.DECODE_POLYLINE_END_POINT;
let DOWNLOAD_LINK_ANDROID = config.DOWNLOAD_LINK_ANDROID;
let DOWNLOAD_LINK_IOS = config.DOWNLOAD_LINK_IOS;
const context = "Home.js";
var self = null;
@inject("appStore")
@observer
class Home extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showProgress: false,
            items: [],
            routes: [],
            pathCoordinates: [],
            lat: 0.0000,
            lng: 0.0000,
            description: "",
            stops_array: []
        };
    }

    componentWillMount = () => {
        self = this;

        this.fetchRouteDetails();
    }

    fetchRouteDetails = () => {

        this.setState({
            showProgress: true
        })
        var route_list = [];
        fetch(UR_GET_ROUTE_DETAILS, {
            method: 'GET'
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (responseJson) {
                try {

                    var resJson = JSON.stringify(responseJson);

                    responseJson.data.forEach(element => {
                        route_list.push(element.name)
                    });
                    self.setState({
                        items: responseJson.data,
                        routes: route_list,
                        showProgress: false
                    })


                    console.log(responseJson)
                } catch (e) {

                }
            })
            .catch(function (error) {


            });
    }



    generateRouteDropDown = (route_josn_array) => {
        var routeListDropDown = null
        routeListDropDown = route_josn_array.map(function (content, i) {
            return (
                <option value={content.name} key={i}>{content.name}</option>
            )
        });

        return routeListDropDown;
    }

    generateStopsUi = (stops_array) => {
        var stopsUi = null;
        stopsUi = stops_array.map(function (element, i) {
            return (
                <div>
                    <a className="btn-get-the-app hover-box-effect" style={{ width: 325, margin: 3 }}>
                        <i className="fa fa-map-marker" ></i> <span style={{ marginLeft: 10, fontSize: 15 }}>{element}</span>
                    </a>
                    {/* <h5><i className="fa fa-map-marker"></i>
                        <span style={{ 'marginLeft': '10px', 'color': 'black', 'fontWeight': '1', marginBottom : 10 }}>
                            {element}</span>
                    </h5> */}
                </div>
            )
        });

        var ui = (<div className="form-group scrollbar" style={{ marginTop: 70, 'overflowY': 'scroll', maxHeight: 400 }} id="style-3">
            {stopsUi}
        </div>)
        return ui;
    }
    decodePolyLine = (event) => {
        var route_name = event.target.value;
        var polyline = null;
        this.state.items.map(function (content, i) {
            if (content.name === route_name) {
                polyline = content.polyline,
                    self.setState({
                        description: content.description,
                        stops_array: content.stop_names
                    })
            }
        });

        console.log(polyline);
        var bodyData = {
            'polyline': polyline
        };

        this.setState({
            showProgress: true
        })
        fetch(URL_DECODE_POLYLINE, {
            method: 'POST',
            body: JSON.stringify(bodyData)
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (responseJson) {
                try {

                    var resJson = JSON.stringify(responseJson);

                    self.setState({
                        pathCoordinates: responseJson.points,
                        lat: responseJson.points[0]['lat'],
                        lng: responseJson.points[0]['lng'],
                        showProgress: false
                    });

                    console.log(responseJson)
                } catch (e) {

                }
            })
            .catch(function (error) {


            });

    }


    componentDidMount = () => {
        //console.log("PROPS", this.props);
    }

    openDownloadLink = (where_to) => {
        var link_to_open = null;
        if (where_to === "android") {
            link_to_open = DOWNLOAD_LINK_ANDROID;
        } else if (where_to === "iOS") {
            link_to_open = DOWNLOAD_LINK_IOS;
        }

        if (link_to_open === null) {

        } else {
            var win = window.open(link_to_open, '_blank');
            win.focus();
        }
    }
    render() {
        var routeDropDownUi = null;
        var stopsUi = null;
        if (this.state.routes.length > 0 && routeDropDownUi == null) {
            routeDropDownUi = this.generateRouteDropDown(this.state.items)
        }
        if (this.state.stops_array.length > 0) {
            stopsUi = this.generateStopsUi(this.state.stops_array)
        }
        return (
            <div>


                <section style={{ 'marginTop': '75px', borderBottom:'5px solid  #6c6b6b' }}>
                    {/* <div className="d-flex"
                        data-owl-animate-in="fadeIn" data-owl-animate-out="fadeOut" data-owl-autoplay="false" data-owl-dots="true"
                        style={{ 'backgroundImage': 'url(assets/img/banner/h2o_banner_01.jpg)', 'height': '600px', 'width': '100%' }}>
                    </div> */}
                    <div style={{ width: '100%' }}>
                        <img src="assets/img/banner/Home Banner_Skool_Preview.jpg" />
                    </div>
                </section>

                <FeaturesSection />
                <Sliderimages/>    
                <Description />



                {/* <section className="pt-120 pb-70 section-pattern" data-bg-img="assets/img/section-pattern/work-process-pattern.png">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="section-title text-center">
                                    <h3>Book a ride in a minute</h3>
                                    <h2>As Easy As Never before...</h2>

                                </div>
                            </div>
                        </div>
                        <div className="row process-bg" style={{ 'backgroundImage': 'url("assets/img/process_shape.png")' }}>
                            <div className="col-lg-3 col-sm-6 single-process-wrapper">
                                <div className="single-process text-center">
                                    <div className="image"> <img src="assets/img/process/process-1.png" data-rjs="2" alt="" /> </div>
                                    <div className="content">
                                        <h3>Download </h3>
                                        <p>App from play store.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-sm-6 single-process-wrapper">
                                <div className="single-process text-center">
                                    <div className="image"> <img src="assets/img/process/process-2.png" data-rjs="2" alt="" /> </div>
                                    <div className="content">
                                        <h3>Search</h3>
                                        <p>For your best comfort route with closest pickup and drop locations and desired time.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-sm-6 single-process-wrapper">
                                <div className="single-process text-center">
                                    <div className="image"> <img src="assets/img/process/process-3.png" data-rjs="2" alt="" /> </div>
                                    <div className="content">
                                        <h3>Payment</h3>
                                        <p>Make payment with easy and quick payment methods.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-sm-6 single-process-wrapper">
                                <div className="single-process text-center">
                                    <div className="image"> <img src="assets/img/process/process-4.png" data-rjs="2" alt="" /> </div>
                                    <div className="content">
                                        <h3>Book a cab</h3>
                                        <p>Thats it! You are set to go.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}
            </div>
        );
    }
}

export default withRouter(Home);


// WEBPACK FOOTER //
// ./src/Pages/Home.js